import { createModel } from '@rematch/core';
import dayjs from 'dayjs';
import { initReduxFn, setStateReducer } from '@/std/redux';
import type { RootModel } from '..';
import type { CaixaBancoState } from './types';
import { effects } from './effects';

const initialState: CaixaBancoState = {
    carregarExtrato: initReduxFn,

    // VALORES PARA DRAWERS
    dadosCompartilhar: null,

    dadosRecibo: undefined,
    estornar: initReduxFn,
    exportarCsv: initReduxFn,
    // EFFECTS
    get: initReduxFn,
    getExtrato: initReduxFn,
    getOne: initReduxFn,
    getRelatorio: initReduxFn,

    // TABELAS
    getTable: {
        // FILTROS
        filterDateRange: {
            end: dayjs(),
            start: dayjs(),
        },
        filterNome: '',
        filterStatus: '',

        // LOADING NA TABELA PARA MOSTRAR ALGUMA AÇÃO EXECUTANDO
        loadingTable: false,

        // PAGINAÇÃO
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: false,
            showTotal: () => '',
            total: 10,
        },
        qtdRegistros: 10,
        registroInitial: 0,

        // LINHA SELECIONADAS
        selectedRow: undefined,
        selectedRows: [],

        // ORDENAÇÃO
        sortParams: {
            fieldName: '',
            orderDirection: 'asc',
            shouldSort: false,
        },

        // TOTAIS REGISTROS (PARA PAGINAÇÃO)
        totalRegistrosTable: 0,

        // UPDATE TABLE ON CHANGES
        updateTable: false,
    },
    getTableExtrato: {
        // FILTROS
        filterDateRange: {
            end: dayjs().endOf('date'),
            start: dayjs().startOf('date').subtract(30, 'day'),
        },
        filterNome: '',

        // LOADING NA TABELA PARA MOSTRAR ALGUMA AÇÃO EXECUTANDO
        loadingTable: false,

        // PAGINAÇÃO
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: false,
            showTotal: () => '',
            total: 10,
        },
        qtdRegistros: 10,
        registroInitial: 0,

        // LINHA SELECIONADAS
        selectedRow: undefined,
        selectedRows: [],

        // ORDENAÇÃO
        sortParams: {
            fieldName: '',
            orderDirection: 'asc',
            shouldSort: false,
        },

        // TOTAIS REGISTROS (PARA PAGINAÇÃO)
        totalRegistrosTable: 0,

        // UPDATE TABLE ON CHANGES
        updateTable: false,
    },

    // IMPRESSÃO
    impressaoRecibo: false,
    impressaoTable: false,
    post: initReduxFn,
    put: initReduxFn,
    remove: initReduxFn,
    removeExtrato: initReduxFn,
    showDrawerBuscarLancamento: false,
    showDrawerCarregarExtrato: false,

    // MOSTRAR DRAWERS
    showDrawerDetalhes: false,
    showDrawerRecibo: false,
    showDrawerTransferenciaEntreContas: false,
    showFiltroAvancado: false,
    totalizador: initReduxFn,
};

export const CaixaBancoModel = createModel<RootModel>()({
    effects,
    reducers: setStateReducer<CaixaBancoState>(),
    state: initialState,
});
